<div class="content_token">
	<h3>Ingresar Token</h3>

	<h4>
		Enviado a <strong> {{ mask_email }} </strong>
	</h4>

	<div>
		<div class="codigo_token">
			<ng-container *ngFor="let item of formArray.controls; let i = index">
				<input
					[formControl]="$any(formArray.controls[i])"
					type="number"
					min="0"
					max="9"
					(keydown)="keyDown(item, $event)"
				/>
			</ng-container>
		</div>
	</div>

	<div class="acciones_enviar_token"><a class="volver_enviar" (click)="clickResend()">Volver a Enviar</a><br /></div>
</div>
